import React from "react";
import { Calendar, momentLocalizer, Event } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Session } from "../../types";

const localizer = momentLocalizer(moment);

interface SessionCalendarProps {
  sessions: Session[];
  onSessionClick: (session: Session) => void;
  onEmptySlotClick: (start: Date) => void;
}

interface CalendarEvent extends Event {
  resource: Session;
}

export const SessionCalendar: React.FC<SessionCalendarProps> = ({
  sessions,
  onSessionClick,
  onEmptySlotClick,
}) => {
  const events: CalendarEvent[] = sessions.map((session) => ({
    title: session.location || "Session sans lieu",
    start: new Date(session.startTime),
    end: new Date(session.endTime),
    resource: session,
  }));

  return (
    <div className="h-full flex flex-col">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100%' }}
        onSelectEvent={(event: CalendarEvent) => onSessionClick(event.resource)}
        onSelectSlot={(slotInfo: { start: Date; }) => onEmptySlotClick(slotInfo.start)}
        selectable
        messages={{
          next: "Suivant",
          previous: "Précédent",
          today: "Aujourd'hui",
          month: "Mois",
          week: "Semaine",
          day: "Jour",
        }}
      />
    </div>
  );
};
